import { createStore } from 'vuex';

export const store = createStore({
  state: () => ({
    isMobile: /(iPhone|Android|Mobile)/gi.test(navigator.userAgent),
    viewType: null, // desktop, tablet or mobile
  }),
  mutations: {
    setViewType(state, payload) {
      state.viewType = payload;
    }
  },
  actions: {},
  getters: {},
})
